import { Loading } from 'react-admin';
import Loadable from 'react-loadable';

const TemplateList = Loadable({ loader: () => import('./templateList'), loading: Loading });
const TemplateCreate = Loadable({ loader: () => import('./templateCreate'), loading: Loading });

export default { 
  list: TemplateList,
  create: TemplateCreate,
};